<!-- Modal -->
<div class="modal fade {{mainClass}}" id="exampleModalError" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- <div class="modal-header">
          <h1 class="modal-title" id="exampleModalLabel">{{ title }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">×</button>
        </div> -->
        <div class="modal-body">
        <button type="button" (click)="saveAndClose()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

        <div class="{{ imageClass }}">
            <img width="{{ imageWidth }}" height="{{ imageHeight }}" [src]="IMAGES_URL" alt="">
        </div>
        <div class="title {{ titleClass }}">
            {{ title }}
        </div>
        <div class="message {{ messageClass }}" innerHTML="{{ message }}">
             <!-- {{ message }} -->
        </div>
        <button (click)="saveAndClose()" type="button" data-bs-dismiss="modal" class="btn modalButton">{{ btnText }}</button>
        </div>
        <!-- <div class="modal-footer">
          <button type="button" class="btn modalButton orange-border" data-bs-dismiss="modal">Cancel</button>
          <button (click)="saveAndClose()" type="button" data-bs-dismiss="modal" class="btn modalButton">Save & Close</button>
        </div> -->
      </div>
    </div>
  </div>
